import React from 'react'
import { TABLA_LINE_UP_BUQUES } from '../../../../config/tables'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'

function TablaBuquesAnunciadosView () {
  return (
    <>
      <MuiTable id={TABLA_LINE_UP_BUQUES} />
    </>
  )
}

export default TablaBuquesAnunciadosView
